export const listLayoutTypes = {
    column: 'column',
    grid: 'grid',
};